import script from "./BrgyClearance.vue?vue&type=script&setup=true&lang=js"
export * from "./BrgyClearance.vue?vue&type=script&setup=true&lang=js"

import "./BrgyClearance.vue?vue&type=style&index=0&id=c052b224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c052b224"]])

export default __exports__